module.exports = __webpack_public_path__ + "static/leopardmain-e8cae2deb69bfd292bbeeb7d4aaa4f1f.png";